(() => {
  const tfCountryPreferenceKey = "tradeframe-country-code"
  const tfCountryQueryParam = "country"
  const tfCountryRefreshParam = "_tf_refresh"
  const tfCountryRetryParam = "_tf_country_retry"
  const tfMaxCountrySyncRetries = 2
  const tfFreeDeliveryCountries = new Set([
    'DE', 'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'GR', 'HU', 'IE', 'IT',
    'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB', 'NO', 'CH',
  ])

  const tfReadCountryPreference = () => {
    try {
      return window.sessionStorage.getItem(tfCountryPreferenceKey)
    } catch (error) {
      return null
    }
  }

  const tfWriteCountryPreference = (countryCode) => {
    try {
      window.sessionStorage.setItem(tfCountryPreferenceKey, countryCode)
    } catch (error) {}
  }

  const tfReadCountryCookie = () => {
    try {
      const countryCookie = document.cookie
        .split("; ")
        .find((cookie) => cookie.startsWith("localization="))
      return countryCookie ? decodeURIComponent(countryCookie.split("=").slice(1).join("=")) : null
    } catch (error) {
      return null
    }
  }

  const tfApplyProductShippingUi = (countryCode, countryData) => {
    const serviceInfo = document.querySelector('.tf-service-info')
    if (!serviceInfo || !countryData || !countryData.name) return

    const shippingType = countryCode === 'US'
      ? 'Us'
      : tfFreeDeliveryCountries.has(countryCode) ? 'Free' : 'Paid'
    const replaceCountry = (value) => value && value.replaceAll('__COUNTRY__', countryData.name)
    const summary = replaceCountry(serviceInfo.dataset[`tfSummary${shippingType}`])
    const answer = replaceCountry(serviceInfo.dataset[`tfAnswer${shippingType}`])

    const summaryDisplay = serviceInfo.querySelector('.tf-service-info__badges span:first-child')
    if (summaryDisplay && summary) summaryDisplay.textContent = summary

    const answerDisplay = serviceInfo.querySelector('.tf-service-info__details details:last-child p')
    if (answerDisplay && answer) {
      const detailsLink = answerDisplay.querySelector('a')
      answerDisplay.replaceChildren(document.createTextNode(`${answer} `))
      if (detailsLink) answerDisplay.append(detailsLink)
    }
  }

  const tfApplyCountryUi = (countryCode) => {
    let countryData = null

    document.querySelectorAll('[data-localization-select]').forEach((select) => {
      const option = Array.from(select.options).find((item) => item.value === countryCode)
      if (!option) return

      if (!countryData) {
        const optionText = option.textContent.replace(/\s+/g, ' ').trim()
        const optionParts = optionText.match(/^(.*)\s+\(([A-Z]{3})\s+(.+)\)$/)
        countryData = option.dataset.countryName
          ? {
              name: option.dataset.countryName,
              currency: option.dataset.countryCurrency,
              symbol: option.dataset.countrySymbol,
            }
          : {
              name: optionParts && optionParts[1],
              currency: optionParts && optionParts[2],
              symbol: optionParts && optionParts[3],
            }
      }

      select.value = countryCode
      const form = select.closest('[data-localization-form]')
      const input = form && form.querySelector('input[data-localization-input]')
      if (input) input.value = countryCode

      const component = select.closest('m-select-component')
      if (!component) return

      const triggerText = component.querySelector('.m-select-custom--trigger-text')
      if (triggerText) triggerText.textContent = option.textContent.trim()

      const triggerFlag = component.querySelector('.m-select-custom--trigger .m-country-flags')
      if (triggerFlag) {
        Array.from(triggerFlag.classList)
          .filter((className) => className.startsWith('m-country-flags--'))
          .forEach((className) => triggerFlag.classList.remove(className))
        triggerFlag.classList.add(`m-country-flags--${countryCode}`)
      }

      component.querySelectorAll('.m-select-custom--option').forEach((customOption) => {
        customOption.classList.toggle('isActive', customOption.dataset.value === countryCode)
      })
      component.optionChecked = countryCode
    })

    if (!countryData || !countryData.name || !countryData.currency) return

    document.querySelectorAll('[data-tf-country-display]').forEach((display) => {
      const baseLabel = `${countryData.name} · ${countryData.currency}`
      display.textContent = display.dataset.tfCountryDisplay === 'full' && countryData.symbol
        ? `${baseLabel} ${countryData.symbol}`
        : baseLabel
    })

    const shippingDisplay = document.querySelector('.tf-international-shipping__destination strong')
    if (shippingDisplay) {
      shippingDisplay.textContent = `${countryData.name} · ${countryData.currency} ${countryData.symbol}`
    }

    const footerDisplay = document.querySelector('.tf-footer-market strong')
    if (footerDisplay) footerDisplay.textContent = `${countryData.name} · ${countryData.currency}`

    tfApplyProductShippingUi(countryCode, countryData)
  }

  const tfCleanCountryParams = (url) => {
    let changed = false
    if (url.searchParams.has(tfCountryQueryParam)) {
      url.searchParams.delete(tfCountryQueryParam)
      changed = true
    }
    if (url.searchParams.has(tfCountryRefreshParam)) {
      url.searchParams.delete(tfCountryRefreshParam)
      changed = true
    }
    if (url.searchParams.has(tfCountryRetryParam)) {
      url.searchParams.delete(tfCountryRetryParam)
      changed = true
    }
    if (changed) {
      window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`)
    }
  }

  const tfSyncRenderedCountry = () => {
    const countryInput = document.querySelector('input[name="country_code"][data-rendered-country]')
    const renderedCountry = countryInput && countryInput.dataset.renderedCountry
    if (!renderedCountry) return

    const currentUrl = new URL(window.location.href)
    const requestedCountry = currentUrl.searchParams.get(tfCountryQueryParam)
    if (requestedCountry === renderedCountry) {
      tfWriteCountryPreference(renderedCountry)
      tfCleanCountryParams(currentUrl)
      return
    }

    const expectedCountry = requestedCountry || tfReadCountryCookie() || tfReadCountryPreference()
    if (!expectedCountry) return

    if (expectedCountry === renderedCountry) {
      tfCleanCountryParams(currentUrl)
      return
    }

    if (document.querySelector('.tf-international-shipping')) {
      tfApplyCountryUi(expectedCountry)
      tfWriteCountryPreference(expectedCountry)
      tfCleanCountryParams(currentUrl)
      return
    }

    const expectedOption = document.querySelector(
      `[data-localization-select] option[value="${expectedCountry}"]`
    )
    const expectedCurrency = expectedOption && (
      expectedOption.dataset.countryCurrency
      || (expectedOption.textContent.replace(/\s+/g, ' ').trim().match(/\(([A-Z]{3})\s+/) || [])[1]
    )
    const activeCurrency = window.Shopify?.currency?.active
      || document.querySelector('[data-active-currency]')?.dataset.activeCurrency
    if (expectedCurrency && activeCurrency === expectedCurrency) {
      tfApplyCountryUi(expectedCountry)
      tfWriteCountryPreference(expectedCountry)
      tfCleanCountryParams(currentUrl)
      return
    }

    const retryValue = Number.parseInt(currentUrl.searchParams.get(tfCountryRetryParam) || "0", 10)
    const retryCount = Number.isFinite(retryValue) ? retryValue : 0
    if (retryCount >= tfMaxCountrySyncRetries) {
      tfApplyCountryUi(expectedCountry)
      tfCleanCountryParams(currentUrl)
      return
    }

    currentUrl.searchParams.set(tfCountryQueryParam, expectedCountry)
    currentUrl.searchParams.set(tfCountryRefreshParam, Date.now().toString())
    currentUrl.searchParams.set(tfCountryRetryParam, (retryCount + 1).toString())
    window.location.replace(currentUrl.toString())
  }

  if (!window.tradeframeCountrySyncBound) {
    window.addEventListener("pageshow", tfSyncRenderedCountry)
    window.tradeframeCountrySyncBound = true
  }

  if (!customElements.get("m-localization-form")) {
    class MLocalizationForm extends HTMLElement {
      constructor() {
        super();
        const select = this.querySelector('[data-localization-select]');
        select && select.addEventListener('change', (e) => {
          const value = e.target.value
          const form = select.closest('[data-localization-form]')
          const input = form.querySelector('input[data-localization-input]')
          if (input) input.value = value
          if (input && input.name === 'country_code') {
            tfWriteCountryPreference(value)
            const returnTo = form.querySelector('input[name="return_to"]')
            if (returnTo) {
              const returnUrl = new URL(returnTo.value, window.location.origin)
              returnUrl.searchParams.set(tfCountryQueryParam, value)
              returnUrl.searchParams.set(tfCountryRefreshParam, Date.now().toString())
              returnUrl.searchParams.set(tfCountryRetryParam, "0")
              returnTo.value = `${returnUrl.pathname}${returnUrl.search}${returnUrl.hash}`
            }
          }
          input && form.submit()
        });
      }
    }
    customElements.define('m-localization-form', MLocalizationForm);
  }
})()
